export * from '@taqueria/protocol/out/types/SingleChar';
